import { __extends } from "tslib";
import { Info } from './Info';
var ScriptInfo = /** @class */ (function (_super) {
    __extends(ScriptInfo, _super);
    function ScriptInfo(abc, methodInfo, traits) {
        var _this = _super.call(this, traits) || this;
        _this.abc = abc;
        _this.methodInfo = methodInfo;
        _this.traits = traits;
        _this.global = null;
        _this.state = 0 /* ScriptInfoState.None */;
        return _this;
    }
    ScriptInfo.prototype.trace = function (writer) {
        writer.enter('ScriptInfo');
        this.traits.trace(writer);
        writer.outdent();
    };
    return ScriptInfo;
}(Info));
export { ScriptInfo };
